import { GetFoodBeverageContactType as ApiFoodBeverageContactType } from 'src/api/generated/touring/types';
import { mapCompanyContactType } from '../../../common';
import { FoodBeverageContactType } from '../../types';

export const mapFoodBeverageContactType = (
  apiType: ApiFoodBeverageContactType
): FoodBeverageContactType => {
  return {
    contact: apiType.contact ? mapCompanyContactType(apiType.contact) : null,
    notes: apiType.notes,
  };
};
